import React from 'react';
import { Form, Flex, Input, Button, Radio, Select, Divider, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import ShopSelector from '../shop/select-shop';

export default () => {
    const { isSub: subAccount } = window.__baseInfo;
    const [form] = Form.useForm();
    const isSub = Form.useWatch('isSub', form);
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get('userId');
    const [isSuper, setIsSuper] = React.useState(false);
    const [roles, setRoles] = React.useState([]);

    const typeOptions = [{label: '子账号', value: true}];

    if(!subAccount) typeOptions.push({label: '总账号', value: false});
    
    const getRoles = async () => {
        const response = await fetch('/api/account/role/list');
        const result = await response.json();

        if (result && result.success) {
            result.data = result.data.map(item => {
                return {
                    label: item.roleTitle,
                    value: item.roleId,
                }
            });
            setRoles(result.data);
        }
    }

    // 获取用户详细信息
    const getUserDetail = async (userId) => {
        
        const response = await fetch(`/api/account/user-detail?userId=${userId}`);
        const result = await response.json();

        if (result && result.success) {
            result.data.roleId = result.data.roleId_role_role_users?.[0].roleId;
            result.data.shops = result.data.shopId_shop_shop_users;
            console.log(result.data);
            
            form.setFieldsValue(result.data);
            setIsSuper( result.data.isSuper );
        }
    }

    React.useEffect(() => {
        getRoles();
        if(userId) {
            getUserDetail(userId);
        }
    }, []);

    const onSubmit = async () => {
        const values = await form.validateFields();
        console.log('values', values);
        const url = userId ? `/api/account/user-edit?userId=${userId}` : '/api/account/user-create';
        // 提交表单
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(values),
        });
        const result = await response.json();

        if (result && result.success) {
            // 提交成功
            message.success('提交成功');
            setTimeout(() => {
                window.location.href = '/account';
            }, 600);
        } else {
            // 提交失败
            message.error(result.data || '提交失败');
        }
    }

    return (
        <div>
            <h2>{userId ? '编辑' : '创建'}账号</h2>
            <Form form={form}>
                <Form.Item
                    label="账号类型"
                    name='isSub'
                    initialValue={typeOptions.length <= 1 ? true : undefined}
                    rules={[{ required: true, message: '' }]}
                    help='子账号只能在指定店铺内使用，总账号可以在所有店铺使用'
                >
                    <Radio.Group disabled={isSuper} optionType='button' options={typeOptions}></Radio.Group>
                </Form.Item>

                <Flex gap={10} align='center'>
                    <Form.Item
                        label="角色"
                        name={'roleId'}
                        rules={[{ required: true, message: '' }]}
                    >
                        <Select options={roles} disabled={isSuper} style={{minWidth: 150}} />
                    </Form.Item>
                    <a href='/account/role-create'>创建角色</a>
                </Flex>

                <Form.Item
                    label="姓名"
                    name='username'
                    rules={[{ required: true, message: '' }]}
                >
                    <Input placeholder="请输入姓名" />
                </Form.Item>

                <Form.Item
                    label="备注"
                    name='remark'
                >
                    <Input placeholder="备注" />
                </Form.Item>

                <Form.Item
                    label="手机号码"
                    name={'phoneNo'}
                    rules={[{ required: true, message: '' }, { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号码" }]}
                >
                    <Input placeholder="" />
                </Form.Item>

                {
                    isSub && <Form.Item
                        label="适用店铺"
                        name='shops'
                        rules={[{ required: true, message: '' }]}
                    >
                        {/* <Select options={[{label: '管理员'}]} /> */}
                        {/* <Button>选择店铺</Button> */}
                        <ShopSelector />
                    </Form.Item>
                }
            </Form>
            <Divider />
            <Flex gap={10} justify='center'>
                <Button size="large" href='/account'>
                    取消
                </Button>
                <Button type="primary" onClick={onSubmit} size="large">
                    提交
                </Button>
            </Flex>
        </div>
    );
};